module.exports = __webpack_public_path__ + "img/upload-icon.38c3f89d.svg";